import React from 'react';
import { X, Plus, Save } from 'lucide-react';

interface WorkoutBuilderProps {
  onClose: () => void;
}

export function WorkoutBuilder({ onClose }: WorkoutBuilderProps) {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Create Workout</h1>
        <button
          onClick={onClose}
          className="text-muted-foreground hover:text-foreground transition-colors"
        >
          <X className="w-6 h-6" />
        </button>
      </div>

      <div className="theme-card p-6 space-y-6">
        {/* Basic Info */}
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1">Workout Name</label>
            <input
              type="text"
              className="w-full px-3 py-2 bg-muted rounded-lg"
              placeholder="e.g., Full Body Strength"
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">Type</label>
              <select className="w-full px-3 py-2 bg-muted rounded-lg">
                <option>Strength</option>
                <option>HIIT</option>
                <option>Cardio</option>
                <option>Recovery</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Duration</label>
              <input
                type="number"
                className="w-full px-3 py-2 bg-muted rounded-lg"
                placeholder="Minutes"
              />
            </div>
          </div>
        </div>

        {/* Exercises */}
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-medium">Exercises</h3>
            <button className="theme-button px-3 py-1.5 rounded-lg text-sm flex items-center gap-1">
              <Plus className="w-4 h-4" />
              Add Exercise
            </button>
          </div>

          <div className="bg-muted/30 p-4 rounded-lg text-center text-muted-foreground">
            No exercises added yet
          </div>
        </div>

        {/* Save Button */}
        <button className="w-full theme-button py-3 rounded-lg flex items-center justify-center gap-2">
          <Save className="w-4 h-4" />
          Save Workout
        </button>
      </div>
    </div>
  );
}